import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Page } from '../components/ui/Page';
import { Button } from '../components/ui/Button';
import { Icon } from '../components/ui/Icon';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Page width="tight" style={{ textAlign: 'center', paddingTop: 80, paddingBottom: 80 }}>
      <div className="mono" style={{ fontSize: 80, fontWeight: 700, color: 'var(--brand-navy)', letterSpacing: '-0.02em' }}>
        404
      </div>
      <h1 style={{ fontSize: 28, marginTop: 8, letterSpacing: '-0.02em' }}>
        This package took a wrong turn.
      </h1>
      <p className="muted" style={{ marginTop: 8 }}>
        The page you're looking for doesn't exist or has been moved.
      </p>
      <div style={{ display: 'flex', gap: 10, justifyContent: 'center', marginTop: 24 }}>
        <Button variant="secondary" onClick={() => navigate(-1)}>
          <Icon name="arrowLeft" size={14} /> Go back
        </Button>
        <Button variant="primary" onClick={() => navigate('/')}>
          <Icon name="home" size={14} /> Home
        </Button>
      </div>
    </Page>
  );
};

export default NotFoundPage;
